import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';

@Component({
    imports: [MatFormFieldModule, MatSelectModule, MatButtonModule],
    selector: 'app-question-upload-modal',
    template: `
    <h2>Select Question Category & Type</h2>
    
    <mat-form-field appearance="fill">
      <mat-label>Category</mat-label>
      <mat-select [(value)]="selectedCategory" (selectionChange)="updateQuestionTypes()">
        @for (cat of categories; track cat) {
          <mat-option [value]="cat">
            {{ cat }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    
    @if (questionTypes.length > 0) {
      <mat-form-field appearance="fill">
        <mat-label>Question Type</mat-label>
        <mat-select [(value)]="selectedType">
          @for (type of questionTypes; track type) {
            <mat-option [value]="type.value">
              {{ type.label }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    
    <div class="actions">
      <button mat-button (click)="close()">Cancel</button>
      <button mat-raised-button class="confirm-button" (click)="confirm()" [disabled]="!selectedType">OK</button>
    </div>
    `,
    styles: [
        `
      .actions {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
      }
      mat-form-field {
        width: 100%;
      }
      .confirm-button{
      background-color: rgba(34, 201, 92, 0.9803921569)
      }
    `
    ]
})
export class QuestionUploadModalComponent {
  selectedCategory: string = '';
  selectedType: string = '';

  categories: string[] = ['Theory', 'Practical', 'Viva'];

  questionTypes: { value: string; label: string }[] = [];

  allQuestionTypes: { [key: string]: { value: string; label: string }[] } = {
    Theory: [
      { value: 'Multiple Choice Question', label: 'MCQ' },
      { value: 'Subjective Answer Question', label: 'Subjective' },
      { value: 'True/False Question', label: 'True/False' },
      { value: 'Fill In The Blanks Question', label: 'Fill in the blanks' },
      { value: 'Matching Questions', label: 'Match the following' },
      {value:'Multi-select Question', label:'Multi-select questions'},
    ],
    Practical: [
      { value: 'Activity - Performance Task', label: 'Activity-performance task' },
      { value: 'Activity - Audio/Video Response', label: 'Activity-audio/video response' },
      { value: 'Activity - File Submission', label: 'Activity-File Submission' },
    ],
    Viva: [
      { value: 'Activity - Real-time Video Streaming Based Viva', label: 'Activity-real-time video streaming based viva' },
    ],
  };
  

  constructor(private dialogRef: MatDialogRef<QuestionUploadModalComponent>) {}

  updateQuestionTypes() {
    this.selectedType = '';
    this.questionTypes = this.allQuestionTypes[this.selectedCategory] || [];
  }

  close() {
    this.dialogRef.close();
  }

  confirm() {
    this.dialogRef.close(this.selectedType,
    );
  }
}
